import React from "react"
import {connect} from "react-redux";

import config from 'config'

import {Badge, Button, Row, Table} from "reactstrap";
import InfoBox from "../InfoBox";
import Loader from "../Loader";
import {fetchSettings, updateSettings} from "../../actions/settingsActions";
import {openModal} from "../../actions/modalActions";

class Settings extends React.PureComponent {

  componentDidMount() {
    this.props.fetchSettings()
  }

  render() {
    const {archivetypes, filters} = this.props.data

    const badges = ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark']

    if (this.props.fetching)
      return <Loader/>

    return <Row>
      { this.props.fetched &&
      <React.Fragment>
        <InfoBox title="Archive types">
          {archivetypes.map((item)=><Badge color={badges[Math.floor(Math.random() * badges.length)]}>{item}</Badge>)}
        </InfoBox>
        <InfoBox title="Filters">
          {Object.keys(filters).map((key)=>(
            <React.Fragment>
              <h4>{key}</h4>
              {filters[key].map((item, i)=><small>{!!i && ", "}{item}</small>)}
            </React.Fragment>
          ))}
        </InfoBox>
      </React.Fragment>
      }
    </Row>

    return null
  }


}
// wraps dispatch to create nicer functions to call within our component
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
  fetchSettings: () => dispatch(fetchSettings()),
  updateSettings: () => updateSettings(),
})

const mapStateToProps = (state) => ({
  fetching: state.settings.fetching,
  fetched: state.settings.fetched,
  error: state.settings.error,
  data: state.settings.data,
})

export default connect(mapStateToProps, mapDispatchToProps)(Settings)


// WEBPACK FOOTER //
// ./src/components/Settings/index.js